module.exports = __webpack_public_path__ + "img/buildings.7e1e249.svg";